import type { Tour } from '../tour-types';

/**
 * Home. Most of its panels only exist in some states (the first-run steps, the waiting
 * panel, the chart once there is data, the table once something is running), and a step
 * whose panel is not on screen simply drops out.
 */
export const homeTour: Tour = {
  key: 'home',
  version: 1,
  routes: ['/'],
  steps: [
    {
      anchor: 'home-attention',
      placement: 'bottom',
      title: 'Needs your attention',
      body: 'Anything waiting on a person shows up here first: a broken test, a result ready to call, a report to write. Each row has a button that takes you to where you deal with it.',
    },
    {
      anchor: 'home-waiting',
      placement: 'bottom',
      title: 'Waiting for first visitors',
      body: 'A test that has started but not recorded anyone yet. If it is still empty after an hour, use Check setup or the checklist underneath to find out why.',
    },
    {
      anchor: 'home-get-started',
      placement: 'bottom',
      title: 'Your first test',
      body: 'These steps take you from an empty dashboard to a running experiment. Each one ticks itself off.',
    },
    {
      anchor: 'home-status',
      placement: 'bottom',
      title: 'Status',
      body: 'Where this website stands right now: how much of its traffic is in a test, what is running, what is still a draft, and winners rolled out to everyone.',
    },
    {
      anchor: 'home-visitors',
      placement: 'top',
      title: 'Visitors',
      body: 'Sessions, conversions and value for the period you pick at the top right. Each figure is compared with the period before it, except under All time.',
    },
    {
      anchor: 'home-chart',
      placement: 'top',
      title: 'Over time',
      body: 'Sessions, conversions and revenue day by day for the same period, to spot a drop or a spike. Revenue reads off the right axis, the counts off the left.',
    },
    {
      anchor: 'home-experiments',
      placement: 'top',
      title: 'Experiment Overview',
      body: 'Every running and deployed experiment on this website with its sessions and dates. Sort by any column, and open one by its name.',
    },
  ],
};
